<template>
  <div>
    <div class="main-title">车辆和设备信息</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="addFormVisible = true">添加车辆</el-button>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchForm)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索车牌号或者设备编号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <!-- 列表 -->
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="id"
          label="系统编号"
          fixed
          width="80">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="所属科目"
          fixed
          width="120">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          fixed
          width="100">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="100">
        </el-table-column>
        <el-table-column
          label="单价"
          width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.price_type === '按小时计费'">{{ scope.row.price_h }}</span>
            <span v-else>{{ scope.row.price_m }}</span>
          </template>
        </el-table-column>
        <!--
        <el-table-column
          prop="price_h"
          label="按小时计费单价"
          width="80">
        </el-table-column>
        -->
        <el-table-column
          prop="status"
          label="车辆状态"
          width="80">
          <template slot-scope="scope">
            <span style="font-weight:bold;" v-if="scope.row.status === '闲置'">{{ scope.row.status }}</span>
            <span style="font-weight:bold;color:green;" v-else-if="scope.row.status === '训练'">{{ scope.row.status }}</span>
            <span style="font-weight:bold;color:red;" v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="device_id"
          label="设备状态"
          width="90"
          :filters="[{ text: '在线', value: '1'}, {text: '离线', value: '2'}, {text: '未安装', value: '3'}]"
          :filter-method="filterDeviceStatus">
          <template slot-scope="scope">
            <span style="font-weight:bold;" v-if="!scope.row.device_id">未安装</span>
            <span style="font-weight:bold;color:red;" v-else-if="isOffline(scope.row.gps_upload_time)">离线</span>
            <span style="font-weight:bold;color:green;" v-else>在线</span>
          </template>
        </el-table-column>
        <el-table-column
          label="车辆控制"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.status === '闲置' && scope.row.device_id" @click="closeOil(scope.row)">断油</el-button>
            <el-button type="text" v-if="scope.row.status !== '闲置' && scope.row.device_id" @click="openOil(scope.row)">恢复油路</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="device_sn"
          label="设备出厂编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="流量卡号"
          width="130">
        </el-table-column>
        <el-table-column
          prop="sim_ex_date"
          label="流量费到期日"
          width="120">
        </el-table-column>
        <el-table-column
          label="发送短信指令"
          width="110">
          <template slot-scope="scope">
            <el-button type="text" @click="sendSMS(scope.row)" v-if="scope.row.phone">发送短信指令</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="device_id"
          label="通讯号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="gps_upload_time"
          label="最后在线时间"
          width="180">
        </el-table-column>
        <!--
          <el-table-column
            prop="sim_serial"
            label="流量卡序列号"
            width="200">
          </el-table-column>
          <el-table-column
            label="经纬度"
            width="120">
            <template slot-scope="scope">
              {{scope.row.lat}},{{scope.row.lon}}
            </template>
          </el-table-column>
        -->
        <el-table-column
          label="操作"
          fixed="right"
          width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="editCar(scope.row)">修改车辆信息</el-button>
            <el-button type="text" @click="uninstallDevice(scope.row)" v-if="scope.row.gps_id > 0">解除GPS设备</el-button>
            <el-button type="text" @click="installDevice(scope.row)" v-else>安装GPS设备</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加车辆 -->
    <el-dialog title="添加车辆" :visible.sync="addFormVisible">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="200px">
        <el-form-item prop="company_id" label="所属科目">
          <el-select
            v-model="addForm.company_id"
            placeholder="请选择科目"
            style="width:194px;">
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="car_alias" label="车辆编号">
          <el-input v-model="addForm.car_alias" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="licnum" label="车牌号">
          <el-input v-model="addForm.licnum" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="price_m" label="按分钟收费单价">
          <el-input v-model="addForm.price_m" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="price_h" label="按小时收费单价">
          <el-input v-model="addForm.price_h" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="price_type" label="计费方式">
          <el-select v-model="addForm.price_type" style="width:194px;">
            <el-option label="按分钟计费" value="按分钟计费"></el-option>
            <el-option label="按小时计费" value="按小时计费"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
        <el-button @click="addFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改车辆 -->
    <el-dialog :title="editFormTitle" :visible.sync="editFormVisible">
      <el-form :model="editForm" ref="editForm" :rules="editFormRules" label-width="200px">
        <el-form-item prop="car_alias" label="车辆编号">
          <el-input v-model="editForm.car_alias" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="licnum" label="车牌号">
          <el-input v-model="editForm.licnum" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="price_m" label="按分钟收费单价">
          <el-input v-model="editForm.price_m" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="price_h" label="按小时收费单价">
          <el-input v-model="editForm.price_h" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="price_type" label="计费方式">
          <el-select v-model="editForm.price_type" style="width:194px;">
            <el-option label="按分钟计费" value="按分钟计费"></el-option>
            <el-option label="按小时计费" value="按小时计费"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editFormCommit" :loading="editFormCommiting">确 定</el-button>
        <el-button @click="editFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 安装设备 -->
    <el-dialog :title="installFormTitle" :visible.sync="installFormVisible">
      <el-form :model="installForm" ref="installForm" :rules="installFormRules" label-width="200px">
        <el-form-item label="选择GPS设备">
          <el-select v-model="installForm.gps_id" style="width:400px">
            <el-option v-for="gps in gpsList" :key="gps.id" :label="`设备编号:${gps.device_sn} 流量卡号:${gps.phone}`" :value="gps.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="installFormCommit" :loading="installFormCommiting">确 定</el-button>
        <el-button @click="installFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改设备信息 -->
    <!--
    <el-dialog :title="editDeviceFormTitle" :visible.sync="editDeviceFormVisible">
      <el-form :model="editDeviceForm" ref="editDeviceForm" :rules="editDeviceFormRules" label-width="200px">
        <el-form-item label="设备出厂编号">
          <el-input v-model="editDeviceForm.device_sn" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="流量卡号" prop="phone">
          <el-input v-model="editDeviceForm.phone" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="流量卡序列号(卡背面数字)">
          <el-input v-model="editDeviceForm.sim_serial" style="width:194px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editDeviceFormCommit" :loading="editDeviceFormCommiting">确 定</el-button>
        <el-button @click="editDeviceFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    -->
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import moment from 'moment'
export default {
  mixins: [ListFunc],
  data() {
    return {
      sqlcode: 'car_list',
      pageSize: 0,
      companyList: [],
      searchForm: {
        query: '',
        company_ids: []
      },
      addForm: {
        company_id: null,
        car_alias: '',
        licnum: '',
        price_m: 8.33,
        price_h: 500,
        price_type: '按分钟计费'
      },
      addFormRules: {
        company_id: [
          { required: true, message: "请选择所属科目", trigger: "blur" }
        ],
        car_alias: [
          { required: true, message: "请填写车辆编号", trigger: "blur" }
        ],
        licnum: [
          { required: true, message: "请填写车牌号", trigger: "blur" }
        ],
        price_m: [
          { required: true, message: "请输入按分钟收费价格", trigger: "blur" }
        ],
        price_h: [
          { required: true, message: "请输入按小时收费价格", trigger: "blur" }
        ],
        price_type: [
          { required: true, message: "请选择计费方式", trigger: "blur" }
        ]
      },
      addFormVisible: false,
      addFormCommiting: false,
      editForm: {
        car_alias: '',
        licnum: '',
        price_type: '按分钟计费',
        price_m: 0,
        price_h: 0
      },
      editFormRules: {
        car_alias: [
          { required: true, message: "请填写车辆编号", trigger: "blur" }
        ],
        licnum: [
          { required: true, message: "请填写车牌号", trigger: "blur" }
        ],
        price_type: [
          { required: true, message: "请选择计费方式", trigger: "blur" }
        ],
        price_m: [
          { required: true, message: "请输入按分钟收费价格", trigger: "blur" }
        ],
        price_h: [
          { required: true, message: "请输入按小时收费价格", trigger: "blur" }
        ]
      },
      editFormTitle: '',
      editFormVisible: false,
      editFormCommiting: false,
      installForm: {
        car_id: 0,
        gps_id: null
      },
      installFormRules: {
        gps_id: [
          { required: true, message: "请选择一个GPS设备", trigger: "blur" }
        ]
      },
      installFormTitle: '',
      installFormVisible: false,
      installFormCommiting: false,
      editDeviceForm: {
        sim_serial: '',
        device_sn: '',
        phone: ''
      },
      editDeviceFormRules: {
        phone: [
          { required: true, message: "请输入流量卡号", trigger: "blur" }
        ]
      },
      editDeviceFormTitle: '',
      editDeviceFormVisible: false,
      editDeviceFormCommiting: false,
      gpsList: []
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.checkSimExDate()
  },
  methods: {
    filterDeviceStatus (value, row) {
      if (value === '3') {
        return !row.device_id
      }
      if (value === '2') {
        return row.device_id && this.isOffline(row.gps_upload_time)
      }
      return row.device_id && !this.isOffline(row.gps_upload_time)
    },
    isOffline (time) {
      if (!time) return true
      return moment().diff(moment(time), 'minutes') > 10
    },
    fetchCompanyList() {
      // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    addFormCommit () { // 添加车辆
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addFormCommiting = true
          this.$http.get('/dbapi/car_info?licnum=' + this.addForm.licnum).then(response => {
            if (response.data.success) {
              if (response.data.list.length > 0) {
                this.addFormCommiting = false
                this.$message({
                  type: 'error',
                  message: '车牌号已存在,请检查'
                })
              } else {
                this.$http.post('/dbapi/insert_car', this.addForm).then(response => {
                  this.addFormCommiting = false
                  if (response.data.success) {
                    this.$message({
                      type: 'success',
                      message: '车辆添加成功'
                    })
                    this.addFormVisible = false
                    this.refresh()
                  } else {
                    this.$message({
                      type: 'error',
                      message: response.data.message
                    })
                  }
                })
              }
            } else {
              this.addFormCommiting = false
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    editCar (row) { // 修改车辆
      this.editForm = {
        id: row.id,
        car_alias: row.car_alias,
        licnum: row.licnum,
        price_m: row.price_m,
        price_h: row.price_h,
        price_type: row.price_type
      }
      this.editFormTitle = `修改车辆: ${row.company_name} / ${row.car_alias} / ${row.licnum}`
      this.editFormVisible = true
    },
    editFormCommit () { // 修改车辆
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editFormCommiting = true
          this.$http.post('/dbapi/update_car', this.editForm).then(response => {
            this.editFormCommiting = false
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: '车辆信息修改成功'
              })
              this.refresh()
              this.editFormVisible = false
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    fetchGpsList () {
      this.$http.get('/dbapi/gps_list?car_id=0').then(response => {
        if (response.data.success) {
          this.gpsList = response.data.list
        }
      })
    },
    installDevice (row) { // 安装设备
      this.installForm = {
        car_id: row.id,
        gps_id: null
      }
      this.fetchGpsList()
      this.installFormTitle = `安装GPS设备: ${row.company_name} / ${row.car_alias} / ${row.licnum}`
      this.installFormVisible = true
    },
    installFormCommit () { // 安装设备
      this.$refs.installForm.validate(valid => {
        if (valid) {
          this.installFormCommiting = true
          this.$http.post('/dbapi/gps_install', this.installForm).then(response => {
            this.installFormCommiting = false
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: 'GPS设备信息登记成功'
              })
              this.refresh()
              this.installFormVisible = false
              let gps = this.gpsList.find(g => g.id == this.installForm.gps_id)
              gps && this.sendSMS({ phone: gps.phone, device_id: gps.device_id })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    uninstallDevice (row) {
      this.$confirm('确定设备已从车上拆除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/gps_uninstall', {
          car_id: row.id,
          gps_id: row.gps_id
        }).then(response => {
          if (response.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    /*
    editDevice (row) { // 修改设备信息
      this.editDeviceForm = {
        id: row.id,
        sim_serial: row.sim_serial,
        phone: row.phone,
        device_sn: row.device_sn
      }
      this.editDeviceFormTitle = `修改设备信息: ${row.company_name} / ${row.car_alias} / ${row.licnum}`
      this.editDeviceFormVisible = true
    },
    editDeviceFormCommit () { // 修改设备信息
      this.$refs.editDeviceForm.validate(valid => {
        if (valid) {
          this.editDeviceFormCommiting = true
          this.$http.post('/dbapi/update_device', this.editDeviceForm).then(response => {
            this.editDeviceFormCommiting = false
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: '设备信息修改成功'
              })
              this.refresh()
              this.editDeviceFormVisible = false
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    */
    sendSMS (row) {
      if (row.phone.indexOf('144') === 0) {
        this.$http.post('/udp/sendsms', {
          phone: row.phone,
          device_id: row.device_id
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '短信发送成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      } else if (row.phone.indexOf('10647') === 0) {
        this.$alert(`在打开的新页面中填写:<br/>
          手机号:&nbsp;<strong style="color:green;">${row.phone}</strong><br/>
          短信内容:<br/>
          <textarea class="el-textarea__inner">&lt;SPBSJ*P:BSJGPS*T:047.099.220.152,0000*U:047.099.220.152,6868*N:${row.device_id}*C:30&gt;</textarea>`, '发送短信指令', {
          dangerouslyUseHTMLString: true
        })
        window.open('http://sim.exlive.cn:89/sim/app/sms/send_duanxin.do')
      } else if (row.phone.indexOf('10649') === 0) {
        this.$alert(`请使用电信手机发送短信给:<br/>
          手机号:&nbsp;<strong style="color:green;">${row.phone}</strong><br/>
          短信内容:<br/>
          <textarea class="el-textarea__inner">&lt;SPBSJ*P:BSJGPS*T:047.099.220.152,0000*U:047.099.220.152,6868*N:${row.device_id}*C:30&gt;</textarea>`, '发送短信指令', {
          dangerouslyUseHTMLString: true
        })
      } else {
        this.$alert(`请使用手机发送短信给:<br/>
          手机号:&nbsp;<strong style="color:green;">${row.phone}</strong><br/>
          短信内容:<br/>
          <textarea class="el-textarea__inner">&lt;SPBSJ*P:BSJGPS*T:047.099.220.152,0000*U:047.099.220.152,6868*N:${row.device_id}*C:30&gt;</textarea>`, '发送短信指令', {
          dangerouslyUseHTMLString: true
        })
      }
    },
    closeOil (row) {
      this.$http.post('/udp/device/close', {
        device_id: row.device_id
      }).then(response => {
        if (response.data.success) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        } else {
          this.$message({
            type: 'error',
            message: '操作失败:' + response.data.message
          })
        }
      })
    },
    openOil (row) {
      this.$http.post('/udp/device/open', {
        device_id: row.device_id
      }).then(response => {
        if (response.data.success) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        } else {
          this.$message({
            type: 'error',
            message: '操作失败:' + response.data.message
          })
        }
      })
    },
    checkSimExDate () {
      this.$http.get('/dbapi/sim_ex_date').then(response => {
        if (response.data.success) {
          let list = response.data.list
          if (list.length > 0) {
            const h = this.$createElement
            let listDiv = []
            for (let i = 0; i < list.length; i++) {
              listDiv.push(h('div', null, `${list[i].company_name}/${list[i].licnum}/流量卡号:${list[i].phone}/到期日期:${list[i].sim_ex_date}`))
            }
            this.$msgbox({
              title: '!!!流量费到期提醒!!!',
              message: h('div', null, [
                h('div', null, [
                  h('span', null, '您有'),
                  h('b', { style: 'color: red' }, list.length.toString()),
                  h('span', null, '台设备流量费即将到期，请注意！！')
                ]),
                ...listDiv
              ]),
              confirmButtonText: '确定'
            })
          }
        }
      })
    }
  }
}
</script>

<style>
.bill-info .el-alert__title {
  font-size: 16px
}
.bill-info .el-alert__description {
  font-size: 14px
}
.bill-info {
  margin-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/data/Car.vue